import { RouteComponentProps } from 'react-router-dom';

export default function useRouteQueryParams<T extends object>(
  location: RouteComponentProps['location']
) {
  const search = new URLSearchParams(location.search);
  const params = Object.fromEntries(search.entries());

  return (params as unknown) as Partial<T>;
}
